import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class NotifyMeComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#checkForSuccess();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  #checkForSuccess() {
    const params = new URLSearchParams(window.location.search);
    const notifySuccess = params.get('notify_success');
    if (!notifySuccess) return;

    const tags = this.refs.notifyTags?.value || '';
    if (!tags.includes(`back-in-stock-${notifySuccess}`)) return;

    this.classList.remove('hidden');
    this.refs.formContent?.classList.add('hidden');
    this.refs.successMessage?.classList.remove('hidden');

    const url = new URL(window.location);
    url.searchParams.delete('notify_success');
    window.history.replaceState({}, '', url);
  }

  #onVariantUpdate = (event) => {
    const productId = this.dataset.productId;
    if (event.detail.data.productId !== productId) return;

    const variant = event.detail.resource;
    const isAvailable = variant?.available === true;

    if (isAvailable) {
      this.classList.add('hidden');
    } else {
      this.classList.remove('hidden');
      this.refs.formContent?.classList.remove('hidden');
      this.refs.successMessage?.classList.add('hidden');

      const newHtml = event.detail.data.html;
      const newNotifyTags = newHtml?.querySelector('notify-me-component [ref="notifyTags"]');
      if (newNotifyTags && this.refs.notifyTags) {
        this.refs.notifyTags.value = newNotifyTags.value;
      }
    }
  };
}

if (!customElements.get('notify-me-component')) {
  customElements.define('notify-me-component', NotifyMeComponent);
}
